import { NAV_DATA_STATISTICS } from '@/pages/performance/constants/nav.js'
const statisticsRoute = [
  {
    path: '/statistics',
    component: () => import('@/pages/performance/layout/index.vue'),
    meta: {
      nav: NAV_DATA_STATISTICS
    },
    children: [
      {
        path: 'view',
        component: () => import('../layout/index.vue'),
        children: [
          {
            path: 'index',
            component: () => import('../data/index.vue')
          }
        ]
      }
    ]
  }
]
export default statisticsRoute
